/**
 * Reads a failed company save (create, edit, or demo create) into the message
 * to show and whether it's about the HubSpot link. The API has no error code
 * for link errors (e.g. already linked to another company), so they're told
 * apart by message. Link errors belong inline on the picker and are expected
 * validation, so callers don't report them as exceptions.
 */
export const getCompanySaveError = (err: unknown, fallback: string) => {
  const error = err as {
    data?: { error_message?: string };
    message?: string;
  };
  const message = error?.data?.error_message || error?.message || fallback;

  return { message, isHubSpotLinkError: /hubspot/i.test(message) };
};
